import { styled } from "@mui/material/styles";
import Box from "@mui/material/Box";
import { grey } from "@mui/material/colors";

export const StyledGreyBadge = styled(Box)(({ display, bgcolor }) => ({
  alignItems: "center",
  paddingLeft: 12,
  paddingRight: 12,
  marginRight: 6,
  borderRadius: 50,
  backgroundColor: bgcolor || grey["100"],
  display: display || "grid",
}));

export const StyledGreyBadgeNoBackgroundOnPrint = styled(Box)(
  ({ display, backgroundcolor }) => ({
    alignItems: "center",
    paddingLeft: 12,
    paddingRight: 12,
    marginRight: 6,
    borderRadius: 50,
    backgroundColor: backgroundcolor || grey["100"],
    display: display || "grid",
    "@media print": {
      padding: 4,
      backgroundColor: "transparent",
      pageBreakInside: "avoid",
    },
  })
);

export const StyledDarkGreyBadge = styled(Box)(({ theme }) => ({
  alignItems: "center",
  paddingLeft: 12,
  paddingRight: 12,
  marginRight: 6,
  borderRadius: 50,
  backgroundColor: grey["300"],
  display: "grid",
}));

export const StyledBadge = styled(Box)(
  ({ bgColor, alignItems, justifyContent, display, marginRight, padding }) => ({
    display: display ?? "block",
    alignItems: alignItems ?? "center",
    justifyContent: justifyContent ?? "center",
    padding: padding || 4,
    marginRight: `${marginRight || 6}px !important`,
    borderRadius: 50,
    backgroundColor: bgColor ?? grey["100"],
  })
);
